import { render, staticRenderFns } from "./FmMultipleChoose.vue?vue&type=template&id=3775781e&scoped=true&"
import script from "./FmMultipleChoose.vue?vue&type=script&lang=js&"
export * from "./FmMultipleChoose.vue?vue&type=script&lang=js&"
import style0 from "./FmMultipleChoose.vue?vue&type=style&index=0&id=3775781e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775781e",
  null
  
)

export default component.exports